// extracted by mini-css-extract-plugin
module.exports = {"main_container":"styles_main_container__2BhJB","content_container":"styles_content_container__2tT51"};